export const KITCHEN_LAYOUT_TYPES = ["linear", "l_shape", "u_shape"];

export const CABINET_RUN_TYPES = ["base", "wall", "tall"];

export const FRONT_TYPES = ["open", "doors", "drawers", "none"];

export const CABINET_ROLES = [
  "standard",
  "sink_base",
  "drawer_base",
  "door_base",
  "corner",
  "oven_tower",
  "fridge_tower",
  "dishwasher",
  "appliance_space",
  "open_shelf",
];

export const APPLIANCE_TYPES = [
  "none",
  "sink",
  "oven",
  "dishwasher",
  "fridge",
  "cooktop",
  "microwave",
];

export const KITCHEN_DESIGN_INTENT_SCHEMA = {
  type: "object",
  additionalProperties: false,
  required: ["version", "layoutType", "runs"],
  properties: {
    version: {
      type: "number",
      enum: [1, 2],
    },

    layoutType: {
      type: "string",
      enum: KITCHEN_LAYOUT_TYPES,
    },

    description: {
      type: "string",
    },

    room: {
  type: "object",
  additionalProperties: false,
  properties: {
    // legacy names
    wallA: { type: "number" },
    wallB: { type: "number" },

    // room editor names
    width: { type: "number" },
    depth: { type: "number" },
    height: { type: "number" },
    wallThickness: { type: "number" },

    baseFloorOffset: { type: "number" },
    wallCabinetOffset: { type: "number" },
    ceilingClearance: { type: "number" },

    showFloor: { type: "boolean" },
    showCeiling: { type: "boolean" },

    walls: {
      type: "array",
      items: {
        type: "object",
        additionalProperties: true,
      },
    },

    openings: {
      type: "array",
      items: {
        type: "object",
        additionalProperties: true,
      },
    },

    services: {
      type: "array",
      items: {
        type: "object",
        additionalProperties: true,
      },
    },
  },
},

    walls: {
      type: "array",
      items: {
        type: "object",
        additionalProperties: true,
        properties: {
          id: { type: "string" },
          name: { type: "string" },
          start: { type: "object" },
          end: { type: "object" },
          height: { type: "number" },
          thickness: { type: "number" },
          inward: { type: "string" },
        },
      },
    },

    materials: {
      type: "object",
      additionalProperties: false,
      properties: {
        corpusBoardMaterialId: { type: "number" },
        corpusEdgeMaterialId: { type: "number" },

        frontBoardMaterialId: { type: "number" },
        frontEdgeMaterialId: { type: "number" },

        backBoardMaterialId: { type: "number" },
        backEdgeMaterialId: { type: "number" },

        shelfBoardMaterialId: { type: "number" },
        shelfEdgeMaterialId: { type: "number" },
      },
    },

    runs: {
      type: "array",
      items: {
        type: "object",
        additionalProperties: false,

        // Bitno:
        // više ne zahtevamo startX/startZ/rotationY,
        // jer wall-based run koristi wallId + offsetFromWallStart.
        required: ["id", "type", "cabinets"],

        properties: {
          id: { type: "string" },

          type: {
            type: "string",
            enum: CABINET_RUN_TYPES,
          },

          // novi wall-based placement
          wallId: { type: "string" },
          offsetFromWallStart: { type: "number" },

          // stari placement ostaje podržan
          startX: { type: "number" },
          startZ: { type: "number" },
          rotationY: { type: "number" },

          defaultHeight: { type: "number" },
          defaultDepth: { type: "number" },
          floorOffset: { type: "number" },

          cabinets: {
            type: "array",
            items: {
              type: "object",
              additionalProperties: false,
              required: ["width"],
              properties: {
                code: { type: "string" },

                type: {
                  type: "string",
                  enum: CABINET_RUN_TYPES,
                },

                width: { type: "number" },
                height: { type: "number" },
                depth: { type: "number" },
                floorOffset: { type: "number" },

                frontType: {
                  type: "string",
                  enum: FRONT_TYPES,
                },

                doorCount: { type: "number" },
                drawerCount: { type: "number" },
                shelfCount: { type: "number" },

                frontGapOuter: { type: "number" },
                frontGapInner: { type: "number" },

                cabinetRole: {
                  type: "string",
                  enum: CABINET_ROLES,
                },

                applianceType: {
                  type: "string",
                  enum: APPLIANCE_TYPES,
                },

                label: { type: "string" },
                note: { type: "string" },
              },
            },
          },
        },
      },
    },
  },
};

export function createEmptyKitchenDesignIntent() {
  return {
    version: 2,
    layoutType: "linear",
    description: "",
    room: {
  width: 3600,
  depth: 2200,
  height: 2800,
  wallThickness: 100,
  baseFloorOffset: 150,
  wallCabinetOffset: 1500,
  ceilingClearance: 50,
  showFloor: true,
  showCeiling: true,
},
walls: [
  {
    id: "back_wall",
    name: "Back wall",
    start: { x: 0, z: 0 },
    end: { x: 3600, z: 0 },
    height: 2800,
    thickness: 100,
    inward: "positive_z",
  },
],
    materials: {},
    runs: [
      {
        id: "back_base",
wallId: "back_wall",
        wallId: "main_wall",
        offsetFromWallStart: 0,
        defaultHeight: 720,
        defaultDepth: 560,
        floorOffset: 150,
        cabinets: [
          {
            width: 600,
            frontType: "doors",
            doorCount: 2,
            shelfCount: 1,
          },
        ],
      },
    ],
  };
}